import { BaseService, type ResponseMessage } from "@kiddocare-platform/portal-common/base";
import type { Policy, PolicyAccepted } from "@kiddocare-platform/portal-common/platform";

export class PlatformLegalService extends BaseService {

    public async getPoliciesByAccount(): Promise<ResponseMessage<Policy[]>> {
    try {
      const response = await this.AxiosInstance.get(`/parent/legal/getPoliciesByAccount`);
      return response.data;
    } catch (error: any) {
      this.log.error("getPoliciesByAccount", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async getAcceptedPoliciesByAccount(): Promise<ResponseMessage<Array<Policy>>> {
    try {
      const response = await this.AxiosInstance.get(`/parent/legal/getAcceptedPoliciesByAccount`);
      return response.data;
    }
    catch (error: any) {
      this.log.error("GetAcceptedPoliciesByAccount", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async insertUserPolicies(policies: Array<PolicyAccepted>): Promise<ResponseMessage<any>> {
    try {
      const response = await this.AxiosInstance.post(`/parent/legal/insertUserPolicies`, policies);
      return response.data;
    } catch (error: any) {
      this.log.error("InsertUserPolicies", error.stack, JSON.stringify(error));
      throw error;
    }
  }

}